import 'react'
import { useMutation } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../../config'

export const manualSync = async (dataSourceId) => {
    const manualSyncAPIPath = `${API_URL}/api/dataSource/v1/manualSync`
    const res = await axios.post(manualSyncAPIPath, { dataSourceId })
    return res.data
}

export function useManualSync() {
    return useMutation(manualSync)
}
